export default __webpack_public_path__ + "static/media/provider_1.d9495560.png";